var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main"},[_c('sawbo-rapid-header'),_c('router-view'),_c('sawbo-rapid-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }